import { createSlice } from '@reduxjs/toolkit';

const locationForm = createSlice({
  name: 'locationForm',
  initialState: {
    name: '',
    address_1: '',
    website: '',
    phoneNumber: '',
    countryCodeId: {
      code: '1',
      country: 'United States',
      id: 232,
    },
    neighborhood: null,
    countryId: 238,
    locality: '',
    region: '',
    postalCode: '',
    latitude: '',
    longitude: '',
    animalTypeIds: [],
    typeIds: [],
  },
  reducers: {
    editLocationForm(state, { payload }) {
      const { key, value } = payload;
      state[key] = value;
    },
    initLocationForm(state, { payload }) {
      return {
        name: payload.name,
        phoneNumber: payload.phone.number,
        countryCodeId: payload.phone.country,
        address_1: payload.address1,
        countryId: 238,
        locality: payload.locality,
        region: payload.region,
        postalCode: payload.postalCode,
        latitude: payload.geo.latitude,
        longitude: payload.geo.longitude,
        animalTypeIds: payload.animal.type.map((el) => el.id),
        typeIds: payload.type.map((el) => el.id),
        website: payload.links?.website || '',
        neighborhood: payload.neighborhood,
      };
    },
    clearLocationData(state) {
      return {
        ...state,
        address_1: null,
        locality: null,
        region: null,
        postalCode: null,
        latitude: null,
        longitude: null,
        neighborhood: null,
      };
    },
  },
});

const { actions, reducer } = locationForm;

export const { editLocationForm, initLocationForm, clearLocationData } =
  actions;

export default reducer;
